export function camelCaseToTitleCase(camelCaseStr: string) {
  return camelCaseStr
    .replace(/([A-Z])/g, " $1") // Add space before capital letters
    .replace(/^./, (str) => str.toUpperCase()) // Capitalize the first letter
    .trim();
}
